<template>
  <div class="wrapper">
    <div class="main-panel">
      <div class="main-content">
        <div class="content-wrapper">
          <div class="container-fluid">
            <section class="basic-elements">
              <div class="row">
                <div class="col-sm-12">
                  <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                  <h2 class="content-header">New user</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="px-3">
                        <form class="form">
                          <user-form :user="user" :newPass="newPass" />
                          <div class="form-actions">
                            <button type="button" class="btn btn-danger mr-1" @click.prevent="back()">
                              <i class="fa fa-arrow-left"></i> Back
                            </button>
                            <button type="button" class="btn btn-success" @click.prevent="createUser()">
                              <i class="icon-note"></i> Save
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <dev-footer />
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user";
import UserForm from './UserForm'
import DevFooter from '../DevFooter'

export default {
  components: {
    UserForm,
    DevFooter
  },
  data: () => {
    return {
      userErrors: [],
      pwdErrors: [],
      newPass: {},
      user: {
        email:'',
        password:'',
        name:'',
        surname: '',
        role: ''
      }
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'home'})
    },
    createUser: async function() {
        if (this.user.password != this.pwc.password) {
          this.errors.push(this.$t("errors.dontMatch"))
        }
        if (this.errors.length == 0) {
          const result = await UserService.create(this.user)
          this.$miniToastr.success(this.$t("flash.createSuccess", ["User"]))
          window.location.href = `/admins/${result.data.id}`
        } else {
          this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
          this.errors = []
        }
        
    },
    createUser: async function() {
      if (!this.newPass.password) {
        this.pwdErrors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.password')]))        
      }
      if (!this.newPass.confirmPassword) {
        this.pwdErrors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.passwordConfirmation')]))        
      }
      if (this.newPass.password != this.newPass.confirmPassword) {
        this.pwdErrors.push(this.$t("errors.dontMatch"))
      }
      if (this.newPass.password && this.newPass.password.length < 8) {
        this.pwdErrors.push(this.$t("errors.passwordLength"))
      }
      if (this.user.name.length == 0) {
        this.euserErrors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.firstName')]))
      }
      if (this.user.surname.length == 0) {
        this.userErrors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.lastName')]))
      }

      if (this.user.email.length == 0) {
        this.userErrors.push(this.$t("errors.cantBeEmpty", ['E-mail']))
      }

      if (!this.emailValidator(this.user.email)) {
          this.userErrors.push(this.$t("errors.invalidEmail"))
      }
      if (this.userErrors.length == 0 && this.pwdErrors.length == 0) {
        this.user.newPass = this.newPass
        const result = await UserService.createUser(this.user)
        if (result.data.success == true) {
          this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.user")]))
          this.$router.push({ name: 'users'})
        } else {
          for (let userError in result.data.userErrors) {
            this.userErrors.push(result.data.userErrors[userError].msg)
          }
          for (let passwordError in result.data.passwordErrors) {
            this.pwdErrors.push(result.data.passwordErrors[passwordError].msg)
          }
          this.$miniToastr.error(this.userErrors.concat(this.pwdErrors).toString().split(",").join("<hr/>"))
          this.userErrors = []
          this.pwdErrors = []
        }
      } else {
        this.$miniToastr.error(this.userErrors.concat(this.pwdErrors).toString().split(",").join("<hr/>"))
        this.userErrors = []
        this.pwdErrors = []
      }
    },
    emailValidator(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    back: function() {
      this.$router.push({ name: 'users' })
    }
  }
};
</script>

<style>
</style>
